export default "__VITE_ASSET__BR8$2hj4__"